module.exports = __webpack_public_path__ + "static/a-poor-wayfaring-man-of-grief-01-29f20587a5bfb00528c10343a28dd398.png";